(function initSubmissionOfferRenderer() {
    function renderSubmissionOffer() {
        (async () => {
            const data = window._submissionOffer;

            if (data && data.marketing_url && !data.configurations) {
                const mediaGallery = document.querySelector('.gp-feature-image-carousel .gp-image-item div:first-child');

                if (!mediaGallery) {
                    return;
                }

                const imageElement = window.cachedImgEl || document.createElement('img');

                if (data && data.marketing_url) {
                    const resizedImageUrl = data.marketing_url.replace("/https", "/q_80,w_720,f_webp/https");
                    imageElement.src = resizedImageUrl;
                    imageElement.srcset = resizedImageUrl;

                    mediaGallery.innerHTML = '';
                    mediaGallery.append(imageElement);
                }
                return
            }

            if (data && data.configurations) {
                // Image configurations may arrive multiple times for the same selector — typically one for
                // 'src' and one for 'srcset'. The attribute is named by `configuration.attribute` (defaulting
                // to 'src' when absent). We strip the element's existing srcset only when no configuration
                // is about to replace it, otherwise the stale theme default would override our new src.
                const imagesBySelector = new Map();
                data.configurations.forEach((configuration) => {
                    if (configuration.type !== 'image') return;
                    if (!imagesBySelector.has(configuration.selector)) {
                        imagesBySelector.set(configuration.selector, []);
                    }
                    imagesBySelector.get(configuration.selector).push(configuration);
                });

                imagesBySelector.forEach((configurations, selector) => {
                    const target = document.querySelector(selector);
                    if (!target) return;

                    const providesSrcset = configurations.some((c) => (c.attribute ?? 'src') === 'srcset');
                    if (!providesSrcset) {
                        target.removeAttribute('srcset');
                    }

                    configurations.forEach((configuration) => {
                        target.setAttribute(configuration.attribute ?? 'src', configuration.value);
                    });
                });

                data.configurations.forEach((configuration) => {
                    if (configuration.type === 'image') return;
                    const target = document.querySelector(configuration.selector);
                    if (!target) return;
                    target.innerHTML = configuration.value;
                });
            }
        })();
    }

    window.renderSubmissionOffer = renderSubmissionOffer;
})();
